module.exports = __webpack_public_path__ + "/images/hellobb-premium-banner-landscape.739164d.png";